import { render, staticRenderFns } from "./InventoryUnLockedTable.vue?vue&type=template&id=5d8c1068"
import script from "./InventoryUnLockedTable.vue?vue&type=script&lang=js"
export * from "./InventoryUnLockedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports